import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import * as Sentry from '@sentry/angular';

const allowSentry = localStorage.getItem('allowSentry');
if (allowSentry == 'true') {
  console.log('🚀 ~ allowSentry:', allowSentry);
  enableSentry();
}

if (environment.production) {
  enableProdMode();
}

console.log('starting at ', environment.firebase.projectId);

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

export function enableSentry() {
  console.log('Enabling Sentry');
  Sentry.init({
    dsn: environment.sentry.dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: environment.sentry.tracesSampleRate,
    tracePropagationTargets: environment.sentry.tracePropagationTargets,
    replaysSessionSampleRate: environment.sentry.replaysSessionSampleRate,
    replaysOnErrorSampleRate: environment.sentry.replaysOnErrorSampleRate,
    enabled: true,
    environment: environment.production ? 'production' : 'development',
    ignoreErrors: ['404 OK|404 Not Found|404'],
  });
}
